import { Link } from 'react-router-dom';
import InlineCTA from './InlineCTA';

const faqList = [
  {
    question: '2026 世足台灣時間幾號開賽？開幕戰是哪一場？',
    answer: '台灣時間 2026 年 6 月 11 日（週四）凌晨 03:00 開幕戰，由地主墨西哥對上小組 A 對手（首戰場館為墨西哥城阿茲特克球場，這是史上首座三度舉辦世足開幕戰的場館）。整個賽期橫跨 6/11 至 7/19，共 39 天 104 場比賽，冠軍戰落在 7/20（一）凌晨 04:00 紐約 MetLife 體育場。多數場次落在台灣早上 06:00–11:00，是「不用熬夜的世足」。',
  },
  {
    question: '開賽前一週還來得及買冠軍盤嗎？賠率會不會比現在差？',
    answer: '截至 5 月初，DraftKings 給西班牙與法國雙雙 +500（並列頭名）、英格蘭 +650、巴西 +800、阿根廷 +850。歷史上開賽前一週賠率會「往熱門收緊、往冷門放開」——也就是說，西法英三強的賠率會繼續往下壓，而摩洛哥、日本、挪威等黑馬則可能往上微升。如果要押熱門，建議在 5/14 法國名單、5/21 德國名單、5/26 美國名單、5/30 英格蘭名單公布前後鎖定，這四個日期是賠率波動最劇烈的窗口。',
  },
  {
    question: '台灣運彩開賽後何時開盤？我現在可以先儲值嗎？',
    answer: '台灣運彩 2026 世足預計沿襲 2022 卡達創舉，提供 104 場全面單場 + 場中投注，含冠軍、金靴、晉級數等 23 項以上特別玩法。現在（5 月）冠軍盤口已經開盤（西班牙 4.50 起、阿根廷 8.00、巴西／法國 8.00），可至實體投注站或台灣運彩官網會員線上儲值投注。請特別注意「不讓分／讓分／大小球」只計 90 分鐘 + 傷停補時，不含延長賽與 PK 大戰。',
  },
  {
    question: '愛爾達 599 季訂划算嗎？還是直接買年訂？',
    answer: '愛爾達 ELTA TV 是台灣 104 場獨家總代理。三個方案：季訂 599（適合只看小組賽到 16 強的輕度球迷）、半年訂 999（涵蓋整個世足賽期 + 賽後集錦）、年訂 1,899（重度球迷划算選擇，可一併追 WBC、亞運）。中華電信 MOD 用戶可透過愛爾達體育 1/2/3 台收看（MOD 月費另計），Hami Video 與愛爾達同步直播。如果你只想看冠軍戰、四強等關鍵場，可先觀望公視／華視是否分潤「免費關鍵場」（截至 5/4 尚未公告）。',
  },
  {
    question: '梅西、C 羅、孫興慜的「Last Dance 三老」分別什麼時候踢首戰？',
    answer: '梅西（38 歲，阿根廷 J 組）、C 羅（41 歲，葡萄牙 K 組）、孫興慜（34 歲，南韓）三人都被定調為「最後一舞」。Modrić（克羅埃西亞 L 組）也在告別行列。具體首戰日期需等 FIFA 公布最終賽程，但根據小組順序推估：阿根廷首戰約落在 6/15、葡萄牙首戰約落在 6/13–14、南韓與克羅埃西亞首戰約落在 6/14–15 區間。三老告別戰是繁中市場最具情緒張力的內容，建議搭配台灣運彩「金靴」、「金球」等特別盤口操作。',
  },
  {
    question: '5 月底還沒看到名單，我該怎麼準備投注？',
    answer: '答案是「分批準備」。5/14 法國名單公布看姆巴佩傷況、5/21 德國名單公布看 Nagelsmann 取捨、5/26 美國名單公布看 Pochettino 主辦國紅利、5/30 英格蘭名單公布看 Bellingham 是否入選、6/1 阿根廷名單公布確認梅西出戰。這五個日期把你的「賽前研究預算」分成五份，每份分配 20%，不要在 5 月初就把資金 all-in 在某一隊。剩餘 30–40% 預算保留到開賽後場中投注用。',
  },
  {
    question: '開賽日衝動下注怎麼避免？',
    answer: '這是世足投注最常見的虧損來源。建議三招：第一，賽前一週把整個 39 天賽期的預算寫成 Google Sheet（例如總預算 10,000 元 ÷ 39 天 = 每日上限 256 元），開盤面前先看一眼數字；第二，開幕戰當天（6/11 凌晨 3:00 墨西哥首戰）只看不押，因為首戰冷門率高、莊家也最謹慎，價值極差；第三，把各種投注群組的通知關掉、把運彩 App 移到手機第三頁，物理增加下注摩擦。詳細資金管理可參考本站世足資金管理專文。',
  },
];

export default function WorldCup2026FinalWeek() {

  return (
    <div>
      <article style={{ maxWidth: 800, margin: '0 auto', lineHeight: 1.8, color: '#e0e0e0' }}>
        <h1>2026 世足開賽前一週懶人包｜必看 5 場小組賽 + 立即下注盤口推薦</h1>

        {/* ========== 導讀 ========== */}
        <p>
          距離 2026 世足開賽剩下不到一週。如果你是第一次認真追世足、或是已經準備好讓這 39 天成為人生最爽的下班儀式，這篇懶人包會幫你在 30 分鐘內完成所有準備：必看的 5 場小組賽、現在還能下注的 7 個冠軍盤口、7 個射手王盤口、Last Dance 三老告別戰時間軸、以及完整的觀賽 + 投注 checklist。
        </p>
        <p>
          本篇是<Link to="/blog/world-cup-2026-guide" style={{ color: '#D4AF37' }}>2026 世界盃投注完整指南</Link>的「賽前一週版本」——不講賽制、不講歷史，只講「未來 7–10 天你要做什麼」。所有資料截至 2026-05-04，5 月名單公布動態已經整合進每個推薦盤口。
        </p>
        <p>
          <strong>重要提醒：</strong>世足投注屬於娛樂消遣，不是穩定獲利的投資工具。請在自己能承受的範圍內理性投注。如果你或認識的人有賭博成癮問題，請撥打求助專線 <strong>衛福部安心專線 1925</strong>（全年無休），遇到疑似詐騙請立即向<a href="https://165.npa.gov.tw" target="_blank" rel="noopener noreferrer">165 反詐騙專線</a>通報。
        </p>

        {/* ========== 倒數 7 天提醒 ========== */}
        <aside style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)', borderLeft: '4px solid #D4AF37', borderRadius: 12, padding: '18px 22px', margin: '24px 0' }}>
          <p style={{ fontWeight: 700, color: '#D4AF37', marginBottom: 8, fontSize: 16 }}>
            開賽倒數提醒｜現在就開始準備
          </p>
          <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
            <li><strong style={{ color: '#fff' }}>愛爾達訂閱</strong>：建議至少提前 3 天訂閱，避免開幕戰當天伺服器塞車</li>
            <li><strong style={{ color: '#fff' }}>台灣運彩會員</strong>：線上會員需驗證身分，新註冊建議預留 24–48 小時審核</li>
            <li><strong style={{ color: '#fff' }}>看球友揪人</strong>：開幕戰凌晨 03:00 適合酒吧聚會，建議 5/30 前訂位</li>
            <li><strong style={{ color: '#fff' }}>39 天預算規劃</strong>：用 Google Sheet 分日預算，避免「開賽日衝動下注」</li>
          </ul>
        </aside>

        {/* ========== 目錄 ========== */}
        <nav aria-label="文章目錄" style={{ background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12, padding: '16px 20px', margin: '24px 0' }}>
          <p style={{ fontWeight: 700, marginBottom: 8, color: '#D4AF37' }}>本文目錄</p>
          <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
            <li><a href="#countdown">一、開賽倒數 7 天：你必須知道的 5 件事</a></li>
            <li><a href="#top5-matches">二、必看小組賽 Top 5（含台灣時間、播放平台、必押盤口）</a></li>
            <li><a href="#champion-7">三、開賽前還能下注的 7 個冠軍盤口</a></li>
            <li><a href="#scorer-7">四、開賽前還能下注的 7 個射手王盤口</a></li>
            <li><a href="#last-dance">五、Last Dance 三老告別戰時間軸</a></li>
            <li><a href="#may-squads">六、5 月名單動態總整理</a></li>
            <li><a href="#tw-checklist">七、台灣球迷觀賽必備 checklist</a></li>
            <li><a href="#bankroll">八、開賽前 7 天投注管理建議</a></li>
            <li><a href="#faq">FAQ 常見問題</a></li>
          </ol>
        </nav>

        {/* ==================== 第 1 節 ==================== */}
        <h2 id="countdown">一、開賽倒數 7 天：你必須知道的 5 件事</h2>
        <p>
          距離 6/11 凌晨 03:00 開幕戰只剩不到一週。在你打開 LINE 揪朋友看球之前，請先把以下 5 件事在腦袋裡釘牢：
        </p>
        <ol>
          <li>
            <strong>賽期 39 天、104 場比賽、48 隊參賽</strong>：史上最大規模世足，比 2022 卡達多 40 場。新賽制 12 組 × 4 隊，每組前 2 名 + 8 個最佳第三名晉級 32 強淘汰賽。「最佳第三名」規則是新賽制最大投注變數，小組賽末輪的「放水比賽」可能增加。
          </li>
          <li>
            <strong>多數場次台灣時間早上 06:00–11:00</strong>：賽事在美加墨進行，徹底顛覆「熬夜看球」刻板印象。上班族可邊吃早餐看上半場、午休前判斷場中盤口。例外只有開幕戰（6/11 凌晨 03:00）與冠軍戰（7/20 凌晨 04:00）兩場需熬夜。
          </li>
          <li>
            <strong>奪冠頭名是西班牙 + 法國雙雄並列 +500</strong>：4 月底 Yamal 賽季報銷+姆巴佩半腱肌傷，把原本西班牙獨大的格局改寫成雙雄並列。英格蘭 +650 緊追，巴西 +800、阿根廷 +850 排名 4–5，葡萄牙 +1100 是最熱門的「第三梯隊」選項。
          </li>
          <li>
            <strong>4 個關鍵名單公布日</strong>：5/14 法國（看姆巴佩）、5/21 德國（Nagelsmann 延後 9 天）、5/26 美國（紐約市發表會）、5/30 英格蘭（Tuchel 取捨 Bellingham）。每個日期都會引發顯著賠率波動，是「莊家反應慢半拍」的價值窗口。
          </li>
          <li>
            <strong>台灣轉播 = 愛爾達獨家 104 場</strong>：季訂 599 / 半年 999 / 年訂 1,899。中華電信 MOD 用戶可走愛爾達體育 1/2/3 台、Hami Video 同步直播適合手機族。公視/華視免費關鍵場（往例為四強、決賽）截至 5/4 尚未公告。
          </li>
        </ol>

        <InlineCTA />

        {/* ==================== 第 2 節 ==================== */}
        <h2 id="top5-matches">二、必看小組賽 Top 5（含台灣時間、播放平台、必押盤口）</h2>
        <p>
          開賽第一週（6/11–6/17）是「整個世足最熱、賠率最浮動、爆冷率最高」的窗口。以下 5 場是<strong>無論你買不買盤都該看完的</strong>必看戰。所有時間以台灣時間為準，賽程細節以 FIFA 官方為準（部分場次因 32 隊→48 隊新賽制 + 三國聯辦時差，FIFA 仍持續微調）。
        </p>

        <h3>第 1 場｜開幕戰：墨西哥 vs 小組 A 對手</h3>
        <ul>
          <li><strong>台灣時間</strong>：6/11（四）凌晨 03:00</li>
          <li><strong>場館</strong>：墨西哥城阿茲特克球場（Estadio Azteca），史上首座三度舉辦世足開幕戰的場館</li>
          <li><strong>播放平台</strong>：愛爾達 ELTA TV / Hami Video（同步）/ 中華電信 MOD</li>
          <li><strong>看點</strong>：地主墨西哥揭幕，FIFA 排名第 15、Aguirre 體系穩定（3 月對葡萄牙 0-0、對比利時 1-1 雙場未敗給 Pot 1 球隊）</li>
          <li><strong>必押盤口建議</strong>：開幕戰歷史上「小球率」高（雙方都緊張），台灣運彩大小球盤口若開 2.5 球，可考慮押「小」；勝平負則建議「平」+「墨西哥小勝」雙押對沖</li>
        </ul>

        <h3>第 2 場｜法國 vs 塞內加爾（姆巴佩出戰待觀察）</h3>
        <ul>
          <li><strong>台灣時間</strong>：6/12（五）約上午 09:00–11:00 區間（FIFA 待確認）</li>
          <li><strong>場館</strong>：美國場館（待 FIFA 公布）</li>
          <li><strong>播放平台</strong>：愛爾達 ELTA TV</li>
          <li><strong>看點</strong>：法國 4 月起重回 FIFA 世界第一、3/26 在 Boston 10 人贏巴西（姆巴佩第 32 分鐘破門、Upamecano 第 55 分鐘紅牌）。但 4/27 皇馬證實姆巴佩左腿半腱肌傷「賽季報銷」，首戰分鐘數是全球頭條級懸念。塞內加爾排名第 14，2002 年法國世足首戰冷門史的當事人。</li>
          <li><strong>必押盤口建議</strong>：姆巴佩若先發，法國讓 1 球可考慮；若姆巴佩替補或缺陣，建議改押「塞內加爾不敗」（隱含勝率約 35–40%）</li>
        </ul>

        <h3>第 3 場｜西班牙 vs Cape Verde（Yamal 缺陣首場）</h3>
        <ul>
          <li><strong>台灣時間</strong>：6/13（六）約上午 09:00–11:00 區間（FIFA 待確認）</li>
          <li><strong>場館</strong>：美國場館（待 FIFA 公布）</li>
          <li><strong>播放平台</strong>：愛爾達 ELTA TV</li>
          <li><strong>看點</strong>：西班牙是奪冠並列頭名（+500）、群組 H 出線首位 -500（隱含 83%）。但 De la Fuente 罕見公開戰術——Yamal 將擔任「joker 替補奇兵」，小組賽謹慎使用、淘汰賽才釋放火力。對首登的 Cape Verde，西班牙仍會以 Oyarzabal（近 10 場 11 球）為箭頭。</li>
          <li><strong>必押盤口建議</strong>：大 2.5 球（Oyarzabal 主場效率高）、西班牙讓 2 球（弱隊缺乏防守韌性）、Oyarzabal 任意時間進球</li>
        </ul>

        <h3>第 4 場｜阿根廷首戰（J 組對奧地利或約旦）</h3>
        <ul>
          <li><strong>台灣時間</strong>：6/14（日）或 6/15（一）區間（FIFA 待確認）</li>
          <li><strong>場館</strong>：美國場館（待 FIFA 公布）</li>
          <li><strong>播放平台</strong>：愛爾達 ELTA TV</li>
          <li><strong>看點</strong>：衛冕軍 + 梅西「最後一舞」（38 歲）。Scaloni 4/1 已用 5-0 痛擊尚比亞展現體系，梅西首發進 2 球助攻 1 次、國家隊生涯第 116 球。但 Scaloni 自己說梅西「remains undecided」是否參賽，6/1 名單公布前不會有定論。J 組阿根廷 -300（隱含 75%）出線首位。</li>
          <li><strong>必押盤口建議</strong>：阿根廷讓 1.5 球、梅西任意時間進球（賠率約 2.20–2.50）、上下半場「半全場阿根廷勝勝」</li>
        </ul>

        <h3>第 5 場｜巴西首戰（C 組對摩洛哥）</h3>
        <ul>
          <li><strong>台灣時間</strong>：6/15（一）或 6/16（二）區間（FIFA 待確認）</li>
          <li><strong>場館</strong>：美國場館（待 FIFA 公布）</li>
          <li><strong>播放平台</strong>：愛爾達 ELTA TV</li>
          <li><strong>看點</strong>：Ancelotti 首屆世足執教（歐洲冠軍級教練接手桑巴），Rodrygo 確定膝傷報銷（賽季 6 個月休養），邊路只能靠 Vinícius、Endrick、Igor Thiago 重組。對手摩洛哥是 2022 4 強防守體系成熟、Hakimi 領袖角色更突出，C 組巴西 -625 但摩洛哥 +500 是「黑馬陪襯」的最佳價值點之一。</li>
          <li><strong>必押盤口建議</strong>：小球 2.5（摩洛哥防守強）、Vinícius 任意時間進球（賠率約 2.00–2.30）、巴西讓 0.5 球（不要追讓 1 球以上）</li>
        </ul>

        {/* ==================== 第 3 節 ==================== */}
        <h2 id="champion-7">三、開賽前還能下注的 7 個冠軍盤口（5 月最新賠率）</h2>
        <p>
          以下 7 個冠軍盤口是分析師反覆點名「開賽前最後窗口」的價值選項。賠率以 DraftKings 截至 2026-04-23 為主，Bet365 與 Polymarket 對照。建議在 5/30 前完成下注（5/30 後英格蘭、阿根廷、巴西名單陸續公布，賠率會劇烈波動）。
        </p>
        <table>
          <thead>
            <tr><th>#</th><th>球隊</th><th>DraftKings</th><th>Bet365</th><th>Polymarket %</th><th>5 月策略</th></tr>
          </thead>
          <tbody>
            <tr><td>1</td><td><strong>法國</strong></td><td>+500（5.00）</td><td>+800（9.00）</td><td>17%</td><td>選 Bet365 +800 顯著價值，Yamal 傷退後法國升溫至預測市場領先</td></tr>
            <tr><td>2</td><td><strong>西班牙</strong></td><td>+500（5.00）</td><td>+450（5.50）</td><td>15%</td><td>等待 Yamal 復原進度，5 月底前若小道消息確認首發則往下壓</td></tr>
            <tr><td>3</td><td>英格蘭</td><td>+650（7.50）</td><td>+550（6.50）</td><td>11%</td><td>5/30 名單公布前下注，Bellingham 若入選會立刻往下壓</td></tr>
            <tr><td>4</td><td>巴西</td><td>+800（9.00）</td><td>+800（9.00）</td><td>9%</td><td>Ancelotti 首屆執教 + Rodrygo 報銷，建議觀望</td></tr>
            <tr><td>5</td><td>阿根廷（衛冕）</td><td>+850（9.50）</td><td>+800（9.00）</td><td>9%</td><td>梅西情勒紅利，但衛冕折扣讓賠率持續上飄</td></tr>
            <tr><td>6</td><td>葡萄牙</td><td>+1100（12.00）</td><td>—</td><td>7%</td><td>K 組好籤（烏茲別克、哥倫比亞、剛果），C 羅最後一舞的最佳冠軍盤</td></tr>
            <tr><td>7</td><td>挪威（黑馬）</td><td>+3000（31.00）</td><td>—</td><td>1–2%</td><td>Haaland 首屆世足 + 8 戰全勝晉級，小額分散押注上限黑馬</td></tr>
          </tbody>
        </table>
        <p>
          <strong>跨平台套利窗口</strong>：法國 DraftKings +500 vs Bet365 +800 出現 300 個基點落差（40% 隱含勝率差）——這是 Bet365 為 2025 年 12 月開盤值未即時調整 Yamal 傷退影響。如果你能在多個平台開戶，鎖定 Bet365 +800 押法國是教科書級的價值賭注。
        </p>
        <p>
          <strong>進階黑馬選項（不在 7 大但值得追蹤）</strong>：摩洛哥 50/1、日本 50/1、墨西哥 75/1（地主延續至 8 強概念）、厄瓜多 90/1（南美外圍賽 18 場僅失 5 球）。完整黑馬分析可參考<Link to="/blog/world-cup-2026-dark-horses" style={{ color: '#D4AF37' }}>2026 世界盃黑馬分析</Link>。
        </p>

        {/* ==================== 第 4 節 ==================== */}
        <h2 id="scorer-7">四、開賽前還能下注的 7 個射手王盤口</h2>
        <p>
          射手王（金靴獎）盤口的最佳投注時機就是「開賽前 1–2 週」——名單已大致確定、傷情趨於穩定、但莊家還沒因為小組賽結果重定價。以下 7 個是 5 月最新分析師共識的價值選項：
        </p>
        <table>
          <thead>
            <tr><th>#</th><th>球員</th><th>國家</th><th>賠率</th><th>5 月策略分析</th></tr>
          </thead>
          <tbody>
            <tr><td>1</td><td><strong>姆巴佩</strong></td><td>法國</td><td>+600</td><td>4/27 半腱肌傷是最大變數，本季皇馬 1.07 進球/場仍是頭號熱門</td></tr>
            <tr><td>2</td><td><strong>Harry Kane</strong></td><td>英格蘭</td><td>+700</td><td>4 月缺席對烏拉圭，預期 6 月歸隊。英格蘭走得遠則金靴穩</td></tr>
            <tr><td>3</td><td>梅西</td><td>阿根廷</td><td>+1200</td><td>「Last Dance 情勒」+ 4/1 對尚比亞先發進 2 球，仍未公開確認參賽</td></tr>
            <tr><td>4</td><td><strong>Haaland</strong></td><td>挪威</td><td>+1400</td><td>外圍賽 8 場進 16 球 + 28 年首次晉級，I 組死亡之組變數大</td></tr>
            <tr><td>5</td><td>Yamal</td><td>西班牙</td><td>+1600</td><td>小組賽「joker 替補奇兵」確認，淘汰賽才上，金靴勝率被官方戰術壓低</td></tr>
            <tr><td>6</td><td><strong>Vinícius Jr.</strong></td><td>巴西</td><td>+2500</td><td>分析師明確點名「期望值最佳」，巴西晉級率 &gt; 法國，賠率被低估</td></tr>
            <tr><td>7</td><td>Lautaro Martínez</td><td>阿根廷</td><td>+2500</td><td>2 月小腿肌拉傷、4 月二度警報，若復原則梅西不能踢的時候他全擔</td></tr>
          </tbody>
        </table>
        <p>
          <strong>射手王投注的核心邏輯</strong>：射手王不只看球員實力，更看「球隊走多遠」。歷屆金靴通常進 6–8 球，等於小組賽 3 場 + 16 強 + 8 強 + 4 強 + 決賽 = 7 場才有機會。所以選射手王 = 選你看好的「至少打到 4 強」的球隊裡的箭頭。從這個邏輯看，Vinícius +2500 確實比 Haaland +1400 更有價值（巴西晉 4 強機率明顯高於挪威）。
        </p>
        <p>
          <strong>排除原因明確的選項</strong>：Bellingham +4000（非射手型 + 帶傷狀態）、C 羅 +2000（41 歲體能 + 葡萄牙無小組死籤但無顯著上限）、Dembélé +2000（在 Doué 取代位置後分鐘數受擠壓）、Nick Woltemade +2000（德國 5/21 才公布名單，仍有變數）。詳細射手王賠率走勢可參考<Link to="/blog/world-cup-2026-top-scorer" style={{ color: '#D4AF37' }}>2026 世界盃射手王預測</Link>。
        </p>

        <InlineCTA />

        {/* ==================== 第 5 節 ==================== */}
        <h2 id="last-dance">五、Last Dance 三老告別戰時間軸</h2>
        <p>
          2026 世足是繁中市場最具情緒張力的一屆——梅西（38）、C 羅（41）、Modrić（40）、孫興慜（34）四位傳奇被韓媒、葡媒、阿媒一致定調為「Last Dance」。其中孫興慜為了世足從 Tottenham 轉會 LAFC，是「為了北美世足選擇北美聯賽」的職涯豪賭，PTT 鄉民熱度爆表。
        </p>

        <h3>梅西時間軸（阿根廷 J 組）</h3>
        <ul>
          <li><strong>5/27</strong>：對尚比亞熱身賽（地點待定，4/1 已先打過一次 5-0）</li>
          <li><strong>6/1</strong>：阿根廷 26 人名單最後截止日，Scaloni 確認「梅西位置 100% 保證」但梅西本人尚未公開確認參賽</li>
          <li><strong>6/14–15 區間</strong>：阿根廷小組賽首戰（J 組對奧地利或約旦）</li>
          <li><strong>看點</strong>：阿根廷 J 組 -300 出線首位幾乎篤定，梅西進球賠率約 2.20–2.50，「梅西首戰任意時間進球」是台灣鄉民熱度最高的盤口</li>
        </ul>

        <h3>C 羅時間軸（葡萄牙 K 組）</h3>
        <ul>
          <li><strong>5 月底</strong>：葡萄牙集訓開始（Martinez 強調「世足出賽不在懷疑範圍」）</li>
          <li><strong>6/13–14 區間</strong>：葡萄牙首戰（K 組對烏茲別克、哥倫比亞、剛果民主之一）</li>
          <li><strong>看點</strong>：第 6 次也是最後一次世足、近 14 場 13 球被 Martinez 視為「X-Factor」。K 組好籤（葡萄牙 -250 出線首位），但哥倫比亞 +250 是死亡之組之一。冠軍盤 +1100 是分析師眼中「最熱門的第三梯隊」選項</li>
        </ul>

        <h3>孫興慜時間軸（南韓）</h3>
        <ul>
          <li><strong>背景</strong>：為世足從 Tottenham 轉會 LAFC，35 歲已轉戰北美聯賽磨合節奏</li>
          <li><strong>5 月底–6 月初</strong>：南韓集訓 + 名單公布</li>
          <li><strong>看點</strong>：南韓 3/28 對象牙海岸 0-4 慘敗（三度中柱），洪明甫體系遭重擊。Son、Kim Min-jae、Lee Kang-in 5/4 為止有部分主力未被召入熱身賽，名單公布是關鍵變數。建議押南韓「不出線」或「小組第三」相關盤口</li>
        </ul>

        <h3>Modrić 時間軸（克羅埃西亞 L 組）</h3>
        <ul>
          <li><strong>背景</strong>：40 歲 Modrić 是 2018 金球獎得主、2022 季軍核心，已宣布世足後退役國家隊</li>
          <li><strong>看點</strong>：L 組與英格蘭同組，英格蘭 -350 出線首位，克羅埃西亞 +350。Modrić 個人盤口（任意時間助攻、上場分鐘數）是隱性價值點</li>
        </ul>

        {/* ==================== 第 6 節 ==================== */}
        <h2 id="may-squads">六、開賽前最後 5 月名單動態總整理</h2>
        <p>
          5 月是世足賽前情報最密集的一個月。FIFA 規定 5/11 內部繳交 35–55 人擴大初選、6/1 各國最終提交 26 人名單。以下是各強隊公布時程，每個日期都會引發顯著賠率波動：
        </p>
        <table>
          <thead>
            <tr><th>日期</th><th>國家</th><th>關鍵看點</th><th>盤口影響</th></tr>
          </thead>
          <tbody>
            <tr><td>5/11</td><td>各隊內部</td><td>35–55 人擴大初選（不對外）</td><td>媒體開始外洩名單，奪冠盤微幅波動</td></tr>
            <tr><td>5/14</td><td><strong>法國</strong></td><td>Deschamps 公布 26 人，姆巴佩傷況揭曉</td><td>姆巴佩若入選 → 法國 +500 往下壓；若缺陣 → 上飄至 +600+</td></tr>
            <tr><td>5/15</td><td>象牙海岸</td><td>最早公布的強隊之一</td><td>影響 H 組讓分盤（與西班牙、烏拉圭同組）</td></tr>
            <tr><td>5/21</td><td><strong>德國</strong></td><td>Nagelsmann 原訂 5/12 延後 9 天，為傷員爭取時間</td><td>德國 +1400 仍是「第三梯隊」、E 組 -400 出線首位篤定</td></tr>
            <tr><td>5/26</td><td><strong>美國</strong></td><td>紐約市發表會 + FOX 直播</td><td>地主紅利的關鍵一錘，Pochettino 取捨會直接影響 Group D +130 的價值</td></tr>
            <tr><td>5/27</td><td>阿根廷</td><td>對尚比亞熱身（地點待定）</td><td>梅西出賽分鐘數會影響「梅西首戰進球」盤口</td></tr>
            <tr><td>5/30</td><td><strong>英格蘭</strong></td><td>Tuchel 截止前公布，Bellingham 是否入選關鍵</td><td>Bellingham 入選 → 英格蘭 +650 立刻收緊至 +550</td></tr>
            <tr><td>5 月底</td><td>巴西</td><td>Ancelotti 預備 26 人集訓，Neymar 是否入選</td><td>Ancelotti 4/12 直言 Neymar「has to prove his fitness」，最終名單仍有變數</td></tr>
            <tr><td>6/1</td><td><strong>阿根廷</strong></td><td>Scaloni「21 人鎖定」，僅梅西位置 100% 保證</td><td>梅西若公開確認參賽 → 阿根廷 +850 往下壓至 +700</td></tr>
          </tbody>
        </table>
        <p>
          <strong>名單公布日的操作策略</strong>：每個公布日都遵循「3 小時黃金窗口」法則——名單發布後 3 小時內，莊家賠率往往來不及反映關鍵動態（如核心球員意外缺陣）。建議在這幾天設手機通知，名單發布後立刻檢視「該隊核心 vs 名單實際」的差異，差異越大、套利空間越大。
        </p>

        {/* ==================== 第 7 節 ==================== */}
        <h2 id="tw-checklist">七、台灣球迷觀賽必備 checklist</h2>
        <p>
          以下是給台灣球迷的「賽前 7 天 to-do list」，按優先順序排列。建議列印或截圖，逐項打勾：
        </p>

        <h3>觀賽轉播訂閱</h3>
        <ul>
          <li>☐ 比較愛爾達季訂 599 / 半年 999 / 年訂 1,899 三個方案，依個人觀賽強度選擇</li>
          <li>☐ 中華電信 MOD 用戶確認愛爾達體育 1/2/3 台是否在套餐內，若否考慮加購</li>
          <li>☐ Hami Video 通勤用戶確認手機 App 已下載並登入</li>
          <li>☐ 觀望公視/華視「免費關鍵場」公告（往例為四強、決賽，截至 5/4 尚未確認）</li>
          <li>☐ 開賽前 3 天測試一次播放品質，避免開幕戰當天才發現問題</li>
        </ul>

        <h3>運彩開戶與儲值</h3>
        <ul>
          <li>☐ 台灣運彩線上會員註冊（新註冊預留 24–48 小時審核期）</li>
          <li>☐ 確認實體投注站位置（運彩官網 → 通路查詢）</li>
          <li>☐ 設定每日投注金額上限（建議 = 月可支配收入的 5% ÷ 39 天）</li>
          <li>☐ 熟悉「不讓分／讓分／大小球」只計 90 分鐘 + 傷停補時的規則</li>
          <li>☐ 評估冠軍盤是否現在下手（5/30 後賠率波動劇烈）</li>
        </ul>

        <h3>看球友揪人 + 場景準備</h3>
        <ul>
          <li>☐ 開幕戰（6/11 凌晨 03:00）酒吧訂位（建議 5/30 前訂）</li>
          <li>☐ 早午餐店看球地圖整理（適合台灣早上 06:00–11:00 黃金時段場次）</li>
          <li>☐ LINE 揪團群組建立（揪 3–5 人共看比較有氣氛）</li>
          <li>☐ 客廳投影儀/電視確認 4K 解析度與愛爾達相容性</li>
          <li>☐ 啤酒、零食、宵夜採購清單（凌晨場準備量加倍）</li>
        </ul>

        <h3>資料追蹤工具</h3>
        <ul>
          <li>☐ FIFA 官方 App 安裝（賽程、即時比分、紅黃牌記錄）</li>
          <li>☐ 設定 Google Calendar 加入 39 天賽程提醒</li>
          <li>☐ Twitter/X 追蹤 @FIFAWorldCup、@beINSPORTS</li>
          <li>☐ Threads 追蹤台灣足球評論員</li>
          <li>☐ Polymarket 加入觀察名單（隱含勝率對照莊家賠率找價值）</li>
        </ul>

        {/* ==================== 第 8 節 ==================== */}
        <h2 id="bankroll">八、開賽前 7 天投注管理建議</h2>
        <p>
          39 天賽期是長期戰，不是短期賽。最常見的虧損模式是「開賽日衝動下注、3 場後本金腰斬、後 36 天靠借錢追」。以下是給賽前 7 天的資金管理 5 步驟：
        </p>

        <h3>步驟 1｜算清楚總預算</h3>
        <p>
          公式：<strong>總預算 = 月可支配收入 × 5–10%</strong>。例如月薪 5 萬扣除房租、伙食、固定支出後可支配 1.5 萬，世足總預算建議 750–1,500 元。<strong>絕對不要動用儲蓄、信用卡或借貸資金</strong>。
        </p>

        <h3>步驟 2｜按賽期分配比例</h3>
        <table>
          <thead>
            <tr><th>階段</th><th>比例</th><th>金額（總預算 1,500 範例）</th><th>用途</th></tr>
          </thead>
          <tbody>
            <tr><td>賽前冠軍盤 + 射手王</td><td>15%</td><td>225 元</td><td>5 月底前鎖定 1–2 個冠軍盤</td></tr>
            <tr><td>小組賽（6/11–6/29，72 場）</td><td>40%</td><td>600 元</td><td>每天 30–40 元上限</td></tr>
            <tr><td>32 強淘汰賽（7/1–7/4）</td><td>15%</td><td>225 元</td><td>每場約 50 元</td></tr>
            <tr><td>16 強 + 8 強（7/5–7/10）</td><td>15%</td><td>225 元</td><td>每場約 20 元</td></tr>
            <tr><td>準決賽 + 決賽（7/14–7/19）</td><td>10%</td><td>150 元</td><td>3 場大戰平均分配</td></tr>
            <tr><td>緊急備援（追平虧損用）</td><td>5%</td><td>75 元</td><td>單筆使用，不可分批</td></tr>
          </tbody>
        </table>

        <h3>步驟 3｜避免「開賽日衝動下注」</h3>
        <p>
          開賽日（6/11）是最容易衝動下注的一天。因為情緒高昂、社群熱度爆表、莊家又會推「開幕戰加碼賠率」吸引流量。<strong>建議開幕戰只看不押</strong>，原因有三：
        </p>
        <ul>
          <li>首戰冷門率高（2022 阿根廷輸沙烏地、德國輸日本是經典案例）</li>
          <li>莊家對地主隊賠率最謹慎，價值極差</li>
          <li>整個賽期才剛開始，第一場輸光會嚴重影響後 38 天判斷力</li>
        </ul>

        <h3>步驟 4｜設定每日投注上限</h3>
        <p>
          用 Google Sheet 建立 39 天投注紀錄表，欄位包含：日期、比賽、盤口、金額、結果、累積損益。<strong>單日達到上限後立刻停手</strong>，不論是贏是輸。連續輸 3 天則暫停 1 天冷靜期。
        </p>

        <h3>步驟 5｜物理增加下注摩擦</h3>
        <ul>
          <li>把運彩 App 移到手機第三頁，需多滑兩下才能開</li>
          <li>關掉投注群組的所有「即時開盤通知」，避免 FOMO 心態</li>
          <li>下注前強迫自己「念出盤口邏輯」三遍，講不清楚就不押</li>
          <li>大額下注（&gt;單日預算 50%）需「睡一晚再決定」</li>
        </ul>
        <p>
          世足投注的長期勝率關鍵不在於「找到神盤」，而在於「39 天後預算還沒燒光」。詳細的資金管理框架可參考<Link to="/blog/bankroll-management-guide" style={{ color: '#D4AF37' }}>運彩資金管理完整指南</Link>，世足專版策略則請看<Link to="/blog/world-cup-2026-bankroll" style={{ color: '#D4AF37' }}>2026 世足資金管理</Link>。
        </p>

        {/* ========== FAQ ========== */}
        <h2 id="faq">FAQ 常見問題</h2>
        {faqList.map((item, i) => (
          <details key={i} style={{ marginBottom: 12, padding: '8px 12px', background: 'rgba(255,255,255,0.03)', borderRadius: 8 }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{item.question}</summary>
            <p style={{ marginTop: 8 }}>{item.answer}</p>
          </details>
        ))}

        {/* ========== 延伸閱讀 ========== */}
        <nav aria-label="延伸閱讀" style={{ marginTop: 40, padding: '16px 20px', background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12 }}>
          <p style={{ fontWeight: 700, color: '#D4AF37', marginBottom: 8 }}>延伸閱讀｜2026 世足系列文章</p>
          <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2.2 }}>
            <li><Link to="/blog/world-cup-2026-guide">2026 世界盃投注完整指南｜48 隊賽制、投注策略與合法管道</Link></li>
            <li><Link to="/blog/world-cup-2026-odds">2026 世界盃賠率分析｜各隊奪冠賠率與黑馬預測</Link></li>
            <li><Link to="/blog/world-cup-2026-groups">2026 世界盃分組深度解析｜12 組對戰形勢與出線預測</Link></li>
            <li><Link to="/blog/world-cup-2026-schedule">2026 世界盃賽程與轉播指南｜完整時間表與台灣時間</Link></li>
            <li><Link to="/blog/world-cup-2026-top-scorer">2026 世界盃射手王預測｜金靴獎賠率與歷史數據</Link></li>
            <li><Link to="/blog/world-cup-2026-dark-horses">2026 世界盃黑馬分析｜最有可能爆冷的隊伍</Link></li>
            <li><Link to="/blog/world-cup-2026-betting-strategy">2026 世界盃盤口攻略｜小組賽與淘汰賽進階策略</Link></li>
            <li><Link to="/blog/messi-world-cup-2026">梅西｜38 歲最後一舞完整分析</Link></li>
            <li><Link to="/blog/ronaldo-world-cup-2026">C 羅｜41 歲告別戰與第 6 屆世足紀錄</Link></li>
            <li><Link to="/blog/mbappe-world-cup-2026">姆巴佩｜27 歲巔峰期的金靴之路</Link></li>
            <li><Link to="/blog/world-cup-2026-bankroll">2026 世足資金管理｜39 天賽期預算分配</Link></li>
          </ul>
        </nav>
      </article>
    </div>
  );
}
